import { Content } from './simple-checkbox.styled';

export const SimpleCheckbox = (props) => {

  return <Content {...props} />
};
